import { render, staticRenderFns } from "./IncidentBriefing.vue?vue&type=template&id=620d2f1b&"
import script from "./IncidentBriefing.vue?vue&type=script&lang=js&"
export * from "./IncidentBriefing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports